import { useAuthFetchWithResult } from '@e3dc-react/shell/Hooks/AuthFetch'

import { AccountLinkModel } from './models/users-account-links-model'
import { AccountLinksDto } from './dto/users-account-links.dto'
import { accountLinksDtoToModelTransformer } from './transformers/users-account-links-transformer'
import { usePortalQuery } from 'src/Libs/api'

/**
 * Function for fetching users account links data
 * @returns account link data as array of AccountLinkModel, isLoading as boolean and isError as boolean
 */
interface UseUsersAccountLinksHook {
  accountLinks: AccountLinkModel[]
  isLoading: boolean
  isError: boolean
  isSuccess: boolean
}
export const useFetchUsersAccountLinks = (installationId: number): UseUsersAccountLinksHook => {
  const authFetch = useAuthFetchWithResult()

  const fetchAccountLinks = async (): Promise<AccountLinksDto> => {
    const accountLinksResponseResponse = authFetch<AccountLinksDto>({
      path: `installations/${installationId}/account-links`,
      method: 'GET',
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
    })

    const response = await accountLinksResponseResponse
    return response
  }

  const { data, isLoading, isError, isSuccess } = usePortalQuery({
    queryFn: () => fetchAccountLinks(),
    queryKey: ['accountLinks', installationId],
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    enabled: !!installationId,
  })

  const accountLinks = accountLinksDtoToModelTransformer(data ?? undefined)

  return {
    accountLinks,
    isLoading,
    isError,
    isSuccess,
  }
}
